const GIFT_WRAP_VARIANT_ID = 52916472906091;

/* --------------------------
   CART HELPERS
-------------------------- */

async function getCart() {
  return fetch('/cart.js').then(res => res.json());
}

async function syncGiftWrapQuantity() {
  const cart = await getCart();

  const wrappedCount = cart.items.filter(
    item => item.properties && item.properties._gift_wrap === 'yes'
  ).length;

  const giftWrapItem = cart.items.find(
    item => item.variant_id === GIFT_WRAP_VARIANT_ID
  );

  // Remove gift wrap if none selected
  if (wrappedCount === 0) {
    if (giftWrapItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftWrapItem.key,
          quantity: 0
        })
      });
    }
    return;
  }

  // Add or sync quantity
  if (!giftWrapItem) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_WRAP_VARIANT_ID,
        quantity: wrappedCount
      })
    });
  } else if (giftWrapItem.quantity !== wrappedCount) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: giftWrapItem.key,
        quantity: wrappedCount
      })
    });
  }
}

/* --------------------------
   REFRESH CART BUBBLE ONLY
-------------------------- */

async function refreshCartBubble() {
  const response = await fetch('/?sections=cart-icon-bubble');
  const sections = await response.json();

  const cartBubble = document.getElementById('cart-icon-bubble');
  if (cartBubble && sections['cart-icon-bubble']) {
    cartBubble.innerHTML = sections['cart-icon-bubble'];
  }
}

/* --------------------------
   MODAL STATE SYNC
-------------------------- */

function openModalsForCheckedItems() {
  document
    .querySelectorAll('.gift-wrap-checkbox:checked')
    .forEach(cb => {
      const modal = document.getElementById(cb.dataset.modalId);
      if (modal) modal.classList.remove('hidden');
    });
}

/* --------------------------
   EVENTS
-------------------------- */

document.addEventListener('click', async function (e) {

  /* ===== CHECKBOX TOGGLE ===== */
  if (e.target.classList.contains('gift-wrap-checkbox')) {

    const checkbox = e.target;
    const lineKey = checkbox.dataset.lineKey;
    const modal = document.getElementById(checkbox.dataset.modalId);

    if (checkbox.checked) {
      if (modal) modal.classList.remove('hidden');

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          properties: { _gift_wrap: 'yes' }
        })
      });

    } else {
      if (modal) modal.classList.add('hidden');

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          properties: { _gift_wrap: null }
        })
      });
    }

    await syncGiftWrapQuantity();
    await refreshCartBubble();

    // Clean reload once to let Dawn re-render totals safely
    window.location.reload();
    return;
  }

  /* ===== SUBMIT GIFT MESSAGE ===== */
  if (e.target.classList.contains('giftSubmit')) {

    const modal = e.target.closest('.gift-wrap-modal');
    if (!modal) return;

    const cartItem = modal.closest('.cart-item');
    if (!cartItem) return;

    const checkbox = cartItem.querySelector('.gift-wrap-checkbox');
    if (!checkbox) return;

    const lineKey = checkbox.dataset.lineKey;

    const message = modal.querySelector('.giftMessage')?.value || '';
    const to = modal.querySelector('.giftTo')?.value || '';
    const from = modal.querySelector('.giftFrom')?.value || '';

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        properties: {
          _gift_wrap: 'yes',
          'Gift Message': message,
          'To': to,
          'From': from
        }
      })
    });

    window.location.reload();
    return;
  }

  /* ===== MODAL CANCEL ===== */
  if (e.target.classList.contains('giftCancel')) {
    const modal = e.target.closest('.gift-wrap-modal');
    if (!modal) return;

    modal.classList.add('hidden');

    const checkbox = modal
      .closest('.cart-item')
      ?.querySelector('.gift-wrap-checkbox');

    if (checkbox && checkbox.checked) {
      checkbox.click();
    }
    return;
  }

  /* ===== MODAL OVERLAY ===== */
  if (e.target.classList.contains('gift-wrap-modal__overlay')) {
    const modal = e.target.closest('.gift-wrap-modal');
    if (modal) modal.classList.add('hidden');
    return;
  }
});

/* --------------------------
   INITIAL LOAD
-------------------------- */

document.addEventListener('DOMContentLoaded', openModalsForCheckedItems);

/* --------------------------
   ISOLATE FROM DAWN
-------------------------- */

['input', 'change', 'keyup', 'focus', 'blur'].forEach(eventType => {
  document.addEventListener(eventType, function (e) {

    if (e.target.closest('.gift-wrap-modal')) {
      e.stopImmediatePropagation();
      return;
    }

    if (e.target.classList.contains('gift-wrap-checkbox')) {
      e.stopImmediatePropagation();
      return;
    }

  }, true);
});